import React from 'react'

const ArrowDownSvg = () => (
  <svg width="19" height="11" viewBox="0 0 19 11">
    <path d="M9.5 11L.2 1.7 1.9 0l7.6 7.6L17.1 0l1.7 1.7z" />
  </svg>
)

export default ArrowDownSvg
